<template>
  <div class="public-content">
    <transition name="fade-in-up">
      <router-view />
    </transition>
  </div>
</template>

<script>

export default {
  name: "PublicLayout",
  components: {

  },

  mounted() {

  },
  methods: {
    
  },
  computed: {

  }
};
</script>

<style lang="css" scoped>

.public-content {
  height: 100vh;
  overflow: auto;
  background-color: white;
}

</style>